import { useState } from 'react';
import type { FieldProps } from './TextField';
import { useFormField } from '../../hooks/useFormField';
import { QuestionWrapper } from '../QuestionWrapper';

export function CheckBoxField({ fieldSchema, group }: FieldProps) {
  const field = useFormField(fieldSchema, group);
  const [checked, setChecked] = useState<boolean>(field.answer === 'True');

  const clickOption = (isChecked: boolean) => {
    setChecked(isChecked);
    field.setAnswer(isChecked ? 'True' : '');
  };

  return (
    <QuestionWrapper {...field} fieldSchema={fieldSchema}>
      <div className="answer-group">
        <div className="answer">
          <input
            type="checkbox"
            checked={checked}
            onChange={(e) => clickOption(e.target.checked)}
            name={`${field.question.id}-0`}
            id={`${field.question.id}-0`}
          />
          <label htmlFor={`${field.question.id}-0`}>
            {field.question.label}{' '}
            {field.question.optional && <span className="optional">(optional)</span>}
          </label>
        </div>
      </div>
    </QuestionWrapper>
  );
}
